module.exports = __webpack_public_path__ + "img/icon_win.a7f06669.png";